import { color } from './color';
import { font, fontSize } from './font';
import { size, padding } from './size';
import { border, borderRadius } from './border';
import { breakpoint } from './breakpoint';

export const theme = {
    border,
    borderRadius,
    breakpoint,
    color,
    font,
    fontSize,
    padding,
    size,
};
